// extracted by mini-css-extract-plugin
export default {"navi_black_bg":"MainNavBar_navi_black_bg__MRD0L","logoBadge":"MainNavBar_logoBadge__2kgpW","list_color":"MainNavBar_list_color__RetqZ"};